// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3sd0U","title":"Info_title__3n1NX","selects":"Info_selects__1fVIb","requiredAsterisk":"Info_requiredAsterisk__2_lAZ"};